@if(visibilityStatus === VisibilityStatus.UNDER_ADMIN_REVIEW){
{{ 'invoice.under_admin_review' | transloco }}
} @else if (visibilityStatus === VisibilityStatus.UNDER_SILENT_ADMIN_REVIEW && invoiceStatus === InvoiceStatus.IN_DISPUTED){
{{ 'invoice.under_admin_review' | transloco }}
} @else if (invoiceStatus === InvoiceStatus.CALCULATION_FAILED) {
{{ 'invoice.calculation_failed' | transloco }}
} @else if (invoiceStatus === InvoiceStatus.CREATED) {
{{ 'invoice.created' | transloco }}
} @else if (invoiceStatus === InvoiceStatus.IN_VALIDATION) {
{{ 'invoice.in_validation' | transloco }}
} @else if (invoiceStatus === InvoiceStatus.VALID) {
{{ 'invoice.valid' | transloco }}
} @else if (invoiceStatus === InvoiceStatus.DATA_MISSING) {
{{ 'invoice.data_missing' | transloco }}
} @else if (invoiceStatus === InvoiceStatus.IN_PROCESSING) {
{{ 'invoice.in_processing' | transloco }}
} @else if (invoiceStatus === InvoiceStatus.DONE) {
{{ 'invoice.done' | transloco }}
} @else if (invoiceStatus === InvoiceStatus.ERROR) {
{{ 'invoice.error' | transloco }}
} @else if (invoiceStatus === InvoiceStatus.IN_DISPUTED) {
{{ 'invoice.in_disputed' | transloco }}
} @else {
{{ 'invoice.review_needed' | transloco }}
}